module.exports = __webpack_public_path__ + "dingbeauty-landing/img/img_client.e27f842c.png";